
import { defineComponent, onMounted, computed, ref } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { useForm } from 'vee-validate'
import { object } from 'yup'
import { myValidationSchemaObj } from '@/views/validation'
import { useStore } from 'vuex'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'

type InputForm = {
  startDate: string;
  endDate: string;
}

const validationSchema = object({
  startDate: myValidationSchemaObj.requiredDate,
  endDate: myValidationSchemaObj.requiredDate
})

export default defineComponent({
  components: {
    DismissibleAlert,
    ContentLayout
  },
  setup () {
    const store = useStore()
    const succeedMessage = ref<string | null>(null)
    const { values, errors, meta, validate, setFieldError } = useForm<InputForm>({
      validationSchema: validationSchema
    })
    const shouldSetDate = computed(() => store.getters.shouldSetDate)

    onMounted(() => {
      values.startDate = store.state.accountingStartDate
      values.endDate = store.state.accountingEndDate
    })

    const setPeriod = () => {
      store.commit('setAccountingStartDate', values.startDate)
      store.commit('setAccountingEndDate', values.endDate)
      succeedMessage.value = '設定しました。'
    }

    const dismiss = () => {
      succeedMessage.value = null
    }

    const onChange = async () => {
      await validate()
      const startDate = Date.parse(values.startDate)
      const endDate = Date.parse(values.endDate)
      if (startDate >= endDate) {
        setFieldError('endDate', '終了日は開始日より未来の日付に設定してください。')
      }
    }

    return {
      succeedMessage,
      values,
      errors,
      meta,
      shouldSetDate,
      onChange,
      setPeriod,
      dismiss
    }
  }
})
